import { EMAILS } from '../global/support/EMAILS';

const OOPS = 'Oops! Something went wrong.';

export const COPY_GENERIC = {
	AND_SPACED: ' and ',
	CANCEL: 'Cancel',
	CLICK_HERE_TO_VIEW: (target: string) => `Click here to view ${target}`,
	COLLAPSE: 'Collapse',
	COLLAPSE_ALL: 'Collapse All',
	CONFIGURE: (value: string) => `Configure ${value}`,
	CONFIRM: 'Confirm',
	CONTACT_SUPPORT: `${OOPS} If this persists, please contact ${EMAILS.SUPPORT} for more help.`,
	CONTACT_SUPPORT_WITH_MESSAGE: `Please contact ${EMAILS.SUPPORT} and provide the following error message:`,
	COULD_NOT_START_EXPORT: 'Could not Start Export',
	CREATE_NEW: (value: string) => `Create New ${value}`,
	DAYS: (value: number) => (Math.abs(value) === 1 ? `${value} Day` : `${value} Days`),
	DISABLE: 'Disable',
	DISABLED: 'Disabled',
	DISMISS: 'Dismiss',
	DOWNLOAD_CSV: 'Download CSV',
	DURATION: 'Duration',
	END: 'End',
	ERROR: 'Error',
	EXPAND: 'Expand',
	EXPAND_ALL: 'Expand All',
	EXPORT_STARTED: 'Your export has started',
	FORCE_DISABLED: 'Force Disabled',
	FORCE_ENABLED: 'Force Enabled',
	FORGOT_PASSWORD_INSTRUCTIONS:
		'If we find your email, you will receive instructions on how to reset your password shortly.',
	FOUND: 'Found',
	FROM: 'From',
	IMPORT_FAILURE: 'Last sync failed to complete successfully.',
	IMPORT_FINISHED_ON: (date: string): string => `Finished running on ${date}.`,
	IMPORT_STARTED_ON: (date: string): string => `Started running on ${date}.`,
	IMPORT_SUCCESS: 'Last sync completed successfully.',
	INFO: 'Info',
	INFORMATION: 'Information',
	INVITE_SUBTEXT: (email: string): string =>
		// eslint-disable-next-line max-len
		`Press the link below to copy the Invitation link to your clipboard, or press Resend Email to resend the invitation email to ${email}.`,
	IN_PROGRESS: 'In Progress',
	LAST_UPDATED: (date: string) => `Last Updated: ${date}`,
	LOG_FOR_SYNC: (status: string) => `Log for ${status} Sync`,
	MAX_FILE_SIZE_EXCEEDED: 'Max file size exceeded',
	NAME_YOUR: (value: string) => `Name Your ${value}`,
	ORGANIZE_BY: (value: string) => `Organize by ${value}`,
	PASSWORD_MESSAGE: (passwordFieldName: string): string => `Please enter a valid ${passwordFieldName}`,
	SAVE: 'Save',
	SCHEDULE: 'Schedule',
	SELECT: (target: string) => `Select ${target}`,
	SHOW_ALL: 'Show All',
	SHOW_HIDDEN: 'Show Hidden',
	SHOW_INACTIVE: 'Show Inactive',
	SHOW_LESS: 'Show Less',
	SHOW_MORE: 'Show More',
	START: 'Start',
	SUCCESS: 'Success',
	SUCCESS_CONNECT_INTEGRATION_OAUTH: (name: string): string => `We're now connected to ${name}.`,
	SUCCESS_DISCONNECT_INTEGRATION_OAUTH: (name: string): string => `We're now disconnected from ${name}.`,
	SYNC_IN_PROGRESS: 'Sync currently in progress...',
	TO: 'To',
	TOO_MANY_EXPORTS: 'Too many exports in progress. Please try again later.',
	UNHANDLED_ERROR: OOPS,
	UNSET: 'Unset',
	WHEN_EXPORT_COMPLETES: `When the export completes,
	you will receive a notification and an email with a link to download the exported data.`
};
